// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.breadcrumb {
  padding: 8px 4px;
}
.breadcrumb__list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.breadcrumb__item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font);
  font-size: 13px;
  line-height: 1;
}
.breadcrumb__item--active {
  font-weight: 600;
}
.breadcrumb__link {
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.15s ease;
  opacity: 0.7;
}
.breadcrumb__link:hover {
  opacity: 1;
  text-decoration: underline;
}
.breadcrumb__link:focus-visible {
  outline: 2px solid;
  outline-offset: 2px;
  border-radius: 2px;
}
.breadcrumb__current {
  font-weight: 600;
}
.breadcrumb__separator {
  opacity: 0.35;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documents/document-breadcrumb/document-breadcrumb.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAIE;EACE,qBAAA;EACA,eAAA;EACA,8BAAA;EACA,YAAA;AAFJ;AAII;EACE,UAAA;EACA,0BAAA;AAFN;AAKI;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AAHN;AAOE;EACE,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AANJ","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.breadcrumb {\n  padding: 8px 4px;\n\n  &__list {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 4px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-family: var(--font);\n    font-size: 13px;\n    line-height: 1;\n\n    &--active {\n      font-weight: 600;\n    }\n  }\n\n  &__link {\n    text-decoration: none;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n    opacity: 0.7;\n\n    &:hover {\n      opacity: 1;\n      text-decoration: underline;\n    }\n\n    &:focus-visible {\n      outline: 2px solid;\n      outline-offset: 2px;\n      border-radius: 2px;\n    }\n  }\n\n  &__current {\n    font-weight: 600;\n  }\n\n  &__separator {\n    opacity: 0.35;\n    font-size: 14px;\n    user-select: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
